export default "__VITE_ASSET__67cda5ee__"